import {
    Login, Signup, Users,
} from 'utils/URLs'
import { get, postWithoutHeader } from 'utils/v2/api'

export const login = (data: any) => postWithoutHeader(`${Login}`, data)
export const signup = (data: any) => postWithoutHeader(`${Signup}`, data)
export const getUsers = () => get(`${Users}`)